// extracted by mini-css-extract-plugin
export var closeButton = "points-widget-module--close-button--8SX0x";
export var pointsWidget = "points-widget-module--points-widget--qA-ik";
export var visible = "points-widget-module--visible--GrLPI";